import React, { Component } from 'react'
import { Card, CardBody, Row, Col, Input } from "reactstrap";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { dataCoberturas } from 'redux/selectors/sPymes'
import ValoresCobertura from './ValoresCobertura'


class CompletarCoberturas extends Component {
    constructor(props) {
        super(props)
        const ubSelec = 0
        const generales = {
            seccion2: 0,
            seccion3: 0
        }
        this.state = { ubSelec, arrayData: [[]], nota: [], guardar: false, generales, estadoGenerales: false, estadoActualizar:false, hasSiguienteUbicacion:true }
        console.log('CONSTRUCTOR')
        // binding es necesario, para cuando se haga la llamada callback desde el componente hijo
        this.setEstadoActualizar = this.setEstadoActualizar.bind(this);
    }
    handleClick = async (datos, i, coberturaEspecial = true) => {
        // props
        const {idCobertura } = this.props
        // visualizar variables de estado del componente
        const { ubSelec, arrayData, nota, guardar, generales, estadoGenerales, estadoActualizar, hasSiguienteUbicacion } = this.state
        // copias de las variables de estado, para no editar el estado directamente
        let stateArrayData
        let stateGuardar
        let stateNota
        let stateGenerales
        let stateEstGenerales
        let stateEstActualizar
        let stateUbSelec
        let stateHasSiguienteUbicacion

        // variables internas                
        let ubicaciones = []

        // Si va a actualizar los valores del tab el usuario
        if(estadoActualizar || !coberturaEspecial){
            stateUbSelec = ubSelec
            stateHasSiguienteUbicacion = hasSiguienteUbicacion
            // deep copy y agregar el dato correspondiente al tab            
            stateArrayData = [...arrayData]
            if(Array.isArray(datos) && datos.length!==0){
                let tabToModify = [...stateArrayData[i]]
                tabToModify = datos
                stateArrayData[i] = tabToModify
            } 

            // Llamar al servicio para guardar los datos llenados en el tab
            let res
            res = await this.props.guardarCobertura({ arrayData: stateArrayData, idCobertura, generales })
            
            // Manejar la respuesta del servicio
            if(res && res.transaccion) {
                stateNota = res.nota ? res.nota : []
                ubicaciones = res.ubicaciones
                stateEstGenerales = res.estadoGenerales
                stateGenerales = res.generales
                let stateArrayData2 = []
                stateArrayData.forEach((item, i) => {
                    let valorItem = []
                    item.forEach((elem, j) => {
                        const val = { ...elem, value: (ubicaciones[i])[elem.codigo] }
                        valorItem.push(val)
                    })
                    stateArrayData2.push(valorItem)
                })
                if(stateArrayData2) {
                    stateArrayData = stateArrayData2
                }
                stateGuardar = true
                stateEstActualizar = false
                // Manejo de botón exterior de actualizar, para cuando se llama en coberturas generales
                if( !coberturaEspecial ){
                    this.setState({ estadoActualizar:false})
                }
            } else {
                stateUbSelec = ubSelec
                stateGuardar = guardar
            }
            // update state
            this.setState({
                ubSelec: stateUbSelec!==undefined ? stateUbSelec : ubSelec,
                arrayData: stateArrayData!==undefined ? stateArrayData : arrayData,
                nota: stateNota!==undefined ? stateNota : nota,
                guardar: stateGuardar!==undefined ? stateGuardar : guardar,
                generales: stateGenerales!==undefined ? stateGenerales : generales,
                estadoGenerales: stateEstGenerales!==undefined ? stateEstGenerales : estadoGenerales,
                estadoActualizar: stateEstActualizar!==undefined ? stateEstActualizar : estadoActualizar
            })

            if (!guardar) window.scroll(0, 0)
            else window.scroll(0, 400)
        }
        else
        {
            // condiciones para ir a la siguiente ubicación de la cobertura actual
            if (guardar && !estadoActualizar && ubSelec < arrayData.length - 1) {
                stateUbSelec = ubSelec + 1
                stateHasSiguienteUbicacion = true
                // this.setState({hasSiguienteUbicacion:true})
                console.log('reachable')
                // detectar cuando ya se recorrieron todas las ubicaciones para una cobertura
                if (stateUbSelec === arrayData.length - 1){
                    stateHasSiguienteUbicacion = false
                    // this.setState({hasSiguienteUbicacion:false})
                    console.log('unreachable')
                }
            }

            // update state
            this.setState({
                ubSelec: stateUbSelec!==undefined ? stateUbSelec : ubSelec,
                hasSiguienteUbicacion: stateHasSiguienteUbicacion!==undefined ? stateHasSiguienteUbicacion : hasSiguienteUbicacion
            })
        }


        // const { arrayUbicaciones, idCobertura } = this.props
        // let { ubSelec, arrayData, nota, guardar, generales, estadoGenerales } = this.state
        // arrayData[i] = datos
        // //let item = arrayData[ubSelec]
        // //item = item.find(item => item.codigo === 'roturaDeVidrios')
        // console.log('RESPUESTA', arrayData, idCobertura, generales, '------------------------------------------')
        // const res = await this.props.guardarCobertura({ arrayData, idCobertura, generales })
        // console.log('RESPUESTA', res)

        // let ubicaciones = []
        // // condiciones para ir a la siguiente ubicación de la cobertura actual
        // if (guardar && !this.state.estadoActualizar && ubSelec < arrayData.length - 1) {
        //     ubSelec = ubSelec + 1
        //     this.setState({hasSiguienteUbicacion:true})
        //     console.log('reachable')
        //     // detectar cuando ya se recorrieron todas las ubicaciones para una cobertura
        //     if (ubSelec === arrayData.length - 1){
        //         this.setState({hasSiguienteUbicacion:false})
        //         console.log('unreachable')
        //     }
        // }

        // if (res.transaccion) {
        //     ubicaciones = res.ubicaciones
        //     estadoGenerales = res.estadoGenerales
        //     console.log('AAAA', res, arrayData, ubicaciones)
        //     // arrayData.forEach((item, i) => this[i] = item.forEach((elem, j) => this[j] = { ...this[j], value: (ubicaciones[i])[elem.codigo] }, item), arrayData)

        //     //arrayData.forEach(item => console.log(item))

        //     let arrayData2 = []
        //     arrayData.forEach((item, i) => {
        //         let valorItem = []

        //         item.forEach((elem, j) => {
        //             const val = { ...elem, value: (ubicaciones[i])[elem.codigo] }
        //             valorItem.push(val)
        //         })
        //         arrayData2.push(valorItem)
        //     })
        //     arrayData = arrayData2
        //     console.log('AAAAres', arrayData)
        //     guardar = true
        //     this.setEstadoActualizar(false)
        // } else {
        //     ubSelec = this.state.ubSelec
        //     guardar = this.state.guardar
        // }

        // this.setState({ arrayData, nota, ubSelec, guardar, estadoGenerales })

        // if (!guardar) window.scroll(0, 0)
        // ///else window.scroll(0, 400)
    }

    componentDidMount() {
        console.log('PYMES4CDMOUNT')
        this.generarArrayData()
        this.setState({estadoActualizar:true})
    }

    handleBack = () => {
        this.setState({hasSiguienteUbicacion:true})
        let { ubSelec } = this.state
        if (ubSelec === 0)
            this.props.handleAtras()
        else {
            ubSelec--
            this.setState({ ubSelec })
        }
    }

    generarArrayData = () => {
        console.log(this.props, this.state)

        const { arrayUbicaciones, data } = this.props
       
        let arrayData = []
        arrayUbicaciones.forEach(({ roturaMaquinaria }) => {
            let data2 = []
            data.forEach(item => data2.push({ ...item, value: 0 }))
            if (roturaMaquinaria) {
                let data3 = []
                data2.forEach(item => {
                    let value = roturaMaquinaria[item.codigo]
                    data3.push({ ...item, value })
                })
                data2 = data3;
            }
            arrayData.push(data2)
        })

        console.log('arrayData1', arrayData)
        this.setState({ arrayData })
    }

    handleGenerales = (valor, codigo, maximo) => {
        valor = parseFloat(valor)
        console.log('VALOR1', valor, codigo, maximo)
        if (isNaN(valor)) valor = 0
        console.log('VALOR2', valor)
        if (valor >= 0) {
            maximo = parseFloat(maximo)
            if (valor <= maximo) {
                let { generales } = this.state
                generales = { ...generales, [codigo]: valor }
                this.setState({ generales, estadoActualizar:true })

            }
        }
    }

    // set para el estado actualizar, que se activa cuando el usuario edita los valores
    setEstadoActualizar = (value) => {
        this.setState({estadoActualizar:value}) 
        console.log('clickActualizar', this.state.estadoActualizar, value)
    }

    render() {

        const { ubSelec, arrayData, nota = [], guardar, generales, estadoGenerales } = this.state
        const { arrayUbicaciones, titulo, nombreGiro, idCobertura, cliCodigoCore, cobGenerales } = this.props
        console.log("DATA", this.props.data)



        return (
            <Col md={8}>
                <div className='row' style={{ background: '#e8eaed', margin: 'auto', padding: 10, marginBottom: 10, }}>
                    <Col sm={6}> <h3 style={{ fontWeight: 700, color: '#b6207f', }}>{titulo}</h3> <div style={{}}> Por favor ingrese los valores que desea asegurar </div> </Col>
                    <Col sm={6} style={{ borderLeft: '2px solid #b3b4b6', }} > <h3 style={{ fontWeight: 700, }}> <center> Giro del negocio: </center> </h3> <div style={{ fontSize: '1.3rem', }}> <center> {nombreGiro} </center> </div>  </Col>
                </div>
                <div className='row'>
                    {arrayData && arrayData.length === 1 && arrayData[0].length === 0 ?
                       

                            <Col md={12} >
                                <Card key={'ubicacionesCobertura0'} >
                                    <CardBody >
                                        <Row className="mb-5 ">

                                            <Col md={12} > <p style={{ display: 'block', margin: 'auto' }}>No se puede realizar esta cobertura, continue con la siguiente </p></Col>

                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        
                        : <>
                            {arrayData.map((data, i) => <div key={`ubicacion${i}`} className={ubSelec === i ? 'col-md-12' : 'divUbicacion col-md-12'}>
                                <Card key={'ubicacionesCober' + i} >
                                    <CardBody >
                                        <div className='container-body-spaces' style={{ marginTop: 10, }} >
                                            {arrayUbicaciones && < div className='flex container-body-spaces' style={{ flexWrap: 'wrap', }}>
                                                {arrayUbicaciones.map((data, i) => {
                                                    let clase = 'botontabs'
                                                    if (!data && ubSelec !== i) clase = `${clase} disabledAll`
                                                    if (ubSelec === i) clase = `botontabsSelected ${clase}`
                                                    return <div key={'botonesUbicacion' + i} className={clase} > {` Ubicación ${i + 1}`} </div>
                                                }
                                                )}
                                            </div>}
                                        </div>
                                        <Row className="mb-5 ">
                                            <Col sm={4} className=" hidden-xs "></Col>
                                            <Col sm={3} className=" hidden-xs "></Col>
                                            <Col sm={5} className=" hidden-xs "> <p style={{ textAlign: 'right', }}>Valor máximo por ubicación</p></Col>
                                        </Row>
                                        {console.log('data_es', data, arrayData)}
                                        {data && data.length > 0 &&
                                            <ValoresCobertura
                                                key={`valCoberturas${i}`}
                                                data={data}
                                                i={i}
                                                handleBack={this.handleBack}
                                                handleClick={this.handleClick}
                                                final={arrayUbicaciones.length - 1 === i}
                                                idCobertura={idCobertura}
                                                cliCodigoCore={cliCodigoCore}
                                                mostrarRotura={guardar}
                                                estadoActualizar={this.state.estadoActualizar}
                                                setEstadoActualizar = {this.setEstadoActualizar}
                                                hasSiguienteUbicacion={this.state.hasSiguienteUbicacion}
                                            />}
                                    </CardBody>
                                </Card> </div>)}
                        </>
                    }
                </div>

                {/* <div className='row card'>
                    <Col md={12} className='card-body' style={{ background: '#fff', }}>
                        <div className='flex' style={{ justifyContent: 'space-between', }}>
                            <label style={{ fontWeight: 700, }}> Coberturas Generales: </label>
                            <label style={{ color: '#909090', }}>Valor Máximo</label>
                        </div>
                        {cobGenerales.map(({ codigo, descripcion, valor }, i) =>
                            <Row key={'coberGenerales' + i}>
                                <Col xs={6} sm={4} > <p>{descripcion}</p> </Col>
                                <Col xs={6} sm={5}>
                                    <Input style={{ width: 'inherit', fontSize: 20, textAlign: 'right', }} value={generales[codigo]} onChange={({ target }) => this.handleGenerales(target.value, codigo, valor)} type='number' />
                                </Col>
                                <Col sm={3}> <p style={{ textAlign: 'right', color: '#909090', }}>{valor.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</p> </Col>
                            </Row>
                        )}
                    </Col>
                    <Col md={12} className='card-body' style={{ background: '#fff' }}>
                        ** El límite ingresado aplica para todas las direcciones cotizadas
                    </Col>
                </div> */}
                {/*nota.length > 0 &&
                    <div className='row card'>
                        <Col md={12} className='card-body' style={{ background: '#fff', }}>
                            <label style={{ fontWeight: 700, }}> Nota: </label>
                            {nota.map((item, i) => <p key={`notasCober${Math.random()}`} >{item}</p>)}
                        </Col></div>} */}

            </Col>
        )
    }
}
const mapStateToProps = (state, props) => ({
    coberturas: state.dataPymes.maxCoberturas,
    cobGenerales: state.dataPymes.coberturasGenerales[props.idCobertura],
    data: dataCoberturas(state, props),
    cliCodigoCore: state.datosUsuarios.dataUsuario.cliCodigoCore,
})

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(CompletarCoberturas)
);